import * as types from "./constant"
export const reset_target = () => {
  return {
    type: types.RESET_TARGET,
  }
}
export const createMonthlyTargetStart = payload => {
  return {
    type: types.CREATE_MONTHLY_TARGET_START,
    payload,
  }
}

export const createMonthlyTargetSuccess = payload => {
  return {
    type: types.CREATE_MONTHLY_TARGET_SUCCESS,
    payload,
  }
}

export const createMonthlyTargetFail = payload => {
  return {
    type: types.CREATE_MONTHLY_TARGET_FAIL,
    payload,
  }
}

export const getMonthlyTargetStart = payload => {
  return {
    type: types.GET_MONTHLY_TARGET_START,
    payload,
  }
}

export const getMonthlyTargetSuccess = payload => {
  return {
    type: types.GET_MONTHLY_TARGET_SUCCESS,
    payload,
  }
}

export const getMonthlyTargetFail = payload => {
  return {
    type: types.GET_MONTHLY_TARGET_FAIL,
    payload,
  }
}

export const updateMonthlyTargetStart = payload => {
  return {
    type: types.UPDATE_MONTHLY_TARGET_START,
    payload,
  }
}

export const updateMonthlyTargetSuccess = payload => {
  return {
    type: types.UPDATE_MONTHLY_TARGET_SUCCESS,
    payload,
  }
}

export const updateMonthlyTargetFail = payload => {
  return {
    type: types.UPDATE_MONTHLY_TARGET_FAIL,
    payload,
  }
}

export const createLOBTargetStart = payload => {
  return {
    type: types.CREATE_LOB_TARGET_START,
    payload,
  }
}

export const createLOBTargetSuccess = payload => {
  return {
    type: types.CREATE_LOB_TARGET_SUCCESS,
    payload,
  }
}

export const createLOBTargetFail = payload => {
  return {
    type: types.CREATE_LOB_TARGET_FAIL,
    payload,
  }
}

export const getLOBTargetStart = payload => {
  return {
    type: types.GET_LOB_TARGET_START,
    payload,
  }
}

export const getLOBTargetSuccess = payload => {
  return {
    type: types.GET_LOB_TARGET_SUCCESS,
    payload,
  }
}

export const getLOBTargetFail = payload => {
  return {
    type: types.GET_LOB_TARGET_FAIL,
    payload,
  }
}

export const updateLOBTargetStart = payload => {
  return {
    type: types.UPDATE_LOB_TARGET_START,
    payload,
  }
}

export const updateLOBTargetSuccess = payload => {
  return {
    type: types.UPDATE_LOB_TARGET_SUCCESS,
    payload,
  }
}

export const updateLOBTargetFail = payload => {
  return {
    type: types.UPDATE_LOB_TARGET_FAIL,
    payload,
  }
}

export const createCompTargetStart = payload => {
  return {
    type: types.CREATE_COMP_TARGET_START,
    payload,
  }
}

export const createCompTargetSuccess = payload => {
  return {
    type: types.CREATE_COMP_TARGET_SUCCESS,
    payload,
  }
}

export const createCompTargetFail = payload => {
  return {
    type: types.CREATE_COMP_TARGET_FAIL,
    payload,
  }
}

export const getCompTargetStart = payload => {
  return {
    type: types.GET_COMP_TARGET_START,
    payload,
  }
}

export const getCompTargetSuccess = payload => {
  return {
    type: types.GET_COMP_TARGET_SUCCESS,
    payload,
  }
}

export const getCompTargetFail = payload => {
  return {
    type: types.GET_COMP_TARGET_FAIL,
    payload,
  }
}

export const updateCompTargetStart = payload => {
  return {
    type: types.UPDATE_COMP_TARGET_START,
    payload,
  }
}

export const updateCompTargetSuccess = payload => {
  return {
    type: types.UPDATE_COMP_TARGET_SUCCESS,
    payload,
  }
}

export const updateCompTargetFail = payload => {
  return {
    type: types.UPDATE_COMP_TARGET_FAIL,
    payload,
  }
}

export const createYearlyTargetStart = payload => {
  return {
    type: types.CREATE_YEARLY_TARGET_START,
    payload,
  }
}

export const createYearlyTargetSuccess = payload => {
  return {
    type: types.CREATE_YEARLY_TARGET_SUCCESS,
    payload,
  }
}

export const createYearlyTargetFail = payload => {
  return {
    type: types.CREATE_YEARLY_TARGET_FAIL,
    payload,
  }
}

export const getYearlyTargetStart = payload => {
  return {
    type: types.GET_YEARLY_TARGET_START,
    payload,
  }
}

export const getYearlyTargetSuccess = payload => {
  return {
    type: types.GET_EMP_TARGET_SUCCESS,
    payload,
  }
}

export const getYearlyTargetFail = payload => {
  return {
    type: types.GET_YEARLY_TARGET_FAIL,
    payload,
  }
}

export const updateYearlyTargetStart = payload => {
  return {
    type: types.UPDATE_YEARLY_TARGET_START,
    payload,
  }
}

export const updateYearlyTargetSuccess = payload => {
  return {
    type: types.UPDATE_MONTHLY_TARGET_SUCCESS,
    payload,
  }
}

export const updateYearlyTargetFail = payload => {
  return {
    type: types.UPDATE_MONTHLY_TARGET_FAIL,
    payload,
  }
}

export const getEmpTargetStart = payload => {
  return {
    type: types.GET_EMP_TARGET_START,
    payload,
  }
}

export const getEmpTargetSuccess = payload => {
  return {
    type: types.GET_EMP_TARGET_SUCCESS,
    payload,
  }
}

export const getEmpTargetFail = payload => {
  return {
    type: types.GET_EMP_TARGET_FAIL,
    payload,
  }
}


export const getComMonthlyStart = () => {
  return {
    type: types.GET_COM_MONTHLY_START,

  }
}


export const getComMonthlySuccess = (payload) => {
  return {
    type: types.GET_COM_MONTHLY_SUCCESS,
    payload

  }
}

export const getComMonthlyFail = (payload) => {
  return {
    type: types.GET_COM_MONTHLY_FAIL,
    payload

  }
}


export const getComYearlyStart = () => {
  return {
    type: types.GET_COM_YEARLY_START,

  }
}


export const getComYearlySuccess = (payload) => {
  return {
    type: types.GET_COM_YEARLY_SUCCESS,
    payload

  }
}

export const getComYearlyFail = (payload) => {
  return {
    type: types.GET_COM_YEARLY_FAIL,
    payload

  }
}


export const getLobMonthlyStart = () =>{
  return{
    type: types.GET_LOB_MONTHLY_START
  }
}

export const getLobMonthlySuccess = (payload) =>{
  return{
    type: types.GET_LOB_MONTHLY_SUCCESS,
    payload
  }
}


export const getLobMonthlyFail = (payload) =>{
  return{
    type: types.GET_LOB_MONTHLY_FAIL,
    payload
  }
}



export const getLobYearlyStart = () =>{
  return{
    type: types.GET_LOB_YEARLY_START
  }
}

export const getLobYearlySuccess = (payload) =>{
  return{
    type: types.GET_LOB_YEARLY_SUCCESS,
    payload
  }
}


export const getLobYearlyFail = (payload) =>{
  return{
    type: types.GET_LOB_YEARLY_FAIL,
    payload
  }
}


export const getYearlyChartStart = () =>{
 return{
  type: types.GET_YEARLY_CHART_START
 }
}

export const getYearlyChartSuccess = (payload) =>{
  return{
   type: types.GET_YEARLY_CHART_SUCCESS,
   payload
  }
 }

 export const getYearlyChartFail = (payload) =>{
  return{
   type: types.GET_YEARLY_CHART_FAIL,
   payload
  }
 }



 export const getMonthlyChartStart = () =>{
  return{
   type: types.GET_MONTHLY_CHART_START
  }
 }
 
 export const getMonthlyChartSuccess = (payload) =>{
   return{
    type: types.GET_MONTHLY_CHART_SUCCESS,
    payload
   }
  }
 
  export const getMonthlyChartFail = (payload) =>{
   return{
    type: types.GET_MONTHLY_CHART_FAIL,
    payload
   }
  }

  export const resetTargetStates = () =>{
    return{
      type: types.RESET_TARGET_STATES
    }
  }